module.exports = {
	"ha": "bc",
	"id": 5.7,
	"report": {
		"ha": "BC",
		"group": "Health Authority",
		"period": "2022 Q1–2023 Q4",
		"lastYear": "2023",
		"lastQuarter": "4"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 60,
			"marginLeft": 100,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 100px;\">Figure 5.7</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for BC by Health Authority, Year Ending 2023 Q4 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -185,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"Linked to Care",
					"Retained in Care",
					"On Treatment",
					"Adherent",
					"Suppressed",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 97.46554024010672,
						"dataLabels": {
							"enabled": true,
							"format": "2192"
						}
					},
					{
						"y": 93.01911960871499,
						"dataLabels": {
							"enabled": true,
							"format": "2092"
						}
					},
					{
						"y": 90.9737661182748,
						"dataLabels": {
							"enabled": true,
							"format": "2046"
						}
					},
					{
						"y": 84.5709204090707,
						"dataLabels": {
							"enabled": true,
							"format": "1902"
						}
					},
					{
						"y": 68.83059137394397,
						"dataLabels": {
							"enabled": true,
							"format": "1548"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.38372093023256,
						"dataLabels": {
							"enabled": true,
							"format": "670"
						}
					},
					{
						"y": 89.09883720930233,
						"dataLabels": {
							"enabled": true,
							"format": "613"
						}
					},
					{
						"y": 87.6453488372093,
						"dataLabels": {
							"enabled": true,
							"format": "603"
						}
					},
					{
						"y": 80.37790697674419,
						"dataLabels": {
							"enabled": true,
							"format": "553"
						}
					},
					{
						"y": 56.83139534883721,
						"dataLabels": {
							"enabled": true,
							"format": "391"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.1830985915493,
						"dataLabels": {
							"enabled": true,
							"format": "276"
						}
					},
					{
						"y": 90.14084507042254,
						"dataLabels": {
							"enabled": true,
							"format": "256"
						}
					},
					{
						"y": 86.26760563380282,
						"dataLabels": {
							"enabled": true,
							"format": "245"
						}
					},
					{
						"y": 73.59154929577466,
						"dataLabels": {
							"enabled": true,
							"format": "209"
						}
					},
					{
						"y": 42.25352112676056,
						"dataLabels": {
							"enabled": true,
							"format": "120"
						}
					},
					{
						"y": null
					},
					{
						"y": 96.7479674796748,
						"dataLabels": {
							"enabled": true,
							"format": "4403"
						}
					},
					{
						"y": 87.21160184574819,
						"dataLabels": {
							"enabled": true,
							"format": "3969"
						}
					},
					{
						"y": 84.68468468468468,
						"dataLabels": {
							"enabled": true,
							"format": "3854"
						}
					},
					{
						"y": 79.38914524280378,
						"dataLabels": {
							"enabled": true,
							"format": "3613"
						}
					},
					{
						"y": 66.77653263019117,
						"dataLabels": {
							"enabled": true,
							"format": "3039"
						}
					},
					{
						"y": null
					},
					{
						"y": 97.84172661870504,
						"dataLabels": {
							"enabled": true,
							"format": "1088"
						}
					},
					{
						"y": 95.86330935251799,
						"dataLabels": {
							"enabled": true,
							"format": "1066"
						}
					},
					{
						"y": 92.7158273381295,
						"dataLabels": {
							"enabled": true,
							"format": "1031"
						}
					},
					{
						"y": 87.05035971223022,
						"dataLabels": {
							"enabled": true,
							"format": "968"
						}
					},
					{
						"y": 63.12949640287769,
						"dataLabels": {
							"enabled": true,
							"format": "702"
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -2.5344597598932816,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.562043795620441,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.198852772466542,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.03812316715543,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -18.611987381703464,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.6162790697674465,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.50746268656717,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.631321370309946,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.29187396351575,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -29.294755877034362,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.8169014084507005,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.246376811594201,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.296875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -14.693877551020407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -42.58373205741627,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.2520325203251987,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.856915739268679,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.897455278407657,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.253243383497664,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.88707445336286,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.1582733812949617,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -2.0220588235294157,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.2833020637898724,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.110572259941804,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -27.47933884297521,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 3,
				"text": "Fraser Health<br>n=2249"
			},
			{
				"x": 9,
				"text": "Interior Health<br>n=688"
			},
			{
				"x": 15,
				"text": "Northern Health<br>n=284"
			},
			{
				"x": 21,
				"text": "Vancouver Coastal Health<br>n=4551"
			},
			{
				"x": 27,
				"text": "Vancouver Island Health<br>n=1112"
			}
		],
		"dataTable": {
			"Fraser Health": [
				2249,
				2192,
				2092,
				2046,
				1902,
				1548
			],
			"Interior Health": [
				688,
				670,
				613,
				603,
				553,
				391
			],
			"Northern Health": [
				284,
				276,
				256,
				245,
				209,
				120
			],
			"Vancouver Coastal Health": [
				4551,
				4403,
				3969,
				3854,
				3613,
				3039
			],
			"Vancouver Island Health": [
				1112,
				1088,
				1066,
				1031,
				968,
				702
			]
		}
	},
	"callback": "C:\\Git\\qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_bc_5_7.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_bc_5_7.json
// module id = 172
// module chunks = 0